import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { useMediaQuery } from 'usehooks-ts'

import useAuthFlow from '@features/auth/hooks/useAuthFlow'
import { useAuth } from '@features/auth/provider'

import { URL_CUSTOMER_PROFILE } from '@shared/contants'
import { useMyBonusTotalQuery } from '@shared/generated'
import { cn } from '@shared/lib/cn'
import Button from '@shared/ui/button'

import styles from './styles.module.scss'



interface CabinetLinkProps {
  className?: string;
}

export default function CabinetLink ({ className }: CabinetLinkProps) {
  const { t: tu } = useTranslation('user')
  const { t: tp } = useTranslation('personal')
  const isTablet = useMediaQuery('(max-width: 768px)')
  const { user, requireRegistration, isAuthorized } = useAuth()
  const navigate = useNavigate()
  const authFlow = useAuthFlow(() =>
    navigate(`${URL_CUSTOMER_PROFILE}`),
  )

  const { data } = useMyBonusTotalQuery()

  const COUNT = data?.myBonus?.activeBonuses ?? 0

  const COUNT_FORMATTED = useMemo(() => COUNT.toLocaleString('ru-RU'), [ COUNT ])

  return (
    <Button
      className={cn(className, styles.root)}
      theme="grey"
      size="large"
      onClick={authFlow}
    >
      <img src="/icons/user.svg" alt="" loading="lazy" fetchPriority="low" />

      {!user && !isTablet && tu('button')}
      {user && !isTablet && user.first_name}

      {isAuthorized && !requireRegistration && (
        <span className={styles.root__count}>
          {COUNT_FORMATTED} {tp('bonusHistory.bonusesAbbreviated')}
        </span>
      )}
    </Button>
  )
}
